/* eslint-disable react/require-default-props */
import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import CSSModules from 'react-css-modules';
import { YOU } from '../../constants/strings';
import { selectUserToShow } from '../../redux/context/selectors';
import Icon from '../Icon';
import styles from './index.styl';

const Card = ({
  additionalContent,
  className,
  text,
  userId,
  providerId,
  loggedUser,
  style,
  additionalIcons,
  handleClick,
  withGreyHover,
}) => {
  let primaryText = text.primary;
  let isLoggedUser = false;
  const intro = (
    <If condition={text.intro}>
      <span className={text.intro} />
    </If>
  );

  if ((userId || providerId) && loggedUser) {
    // avoid comparison if card is used for any other reason then users list
    const comparedId = userId
      ? get(loggedUser, 'id')
      : get(loggedUser, 'primaryProviderProfile.id');
    isLoggedUser = userId ? userId === comparedId : providerId === comparedId;

    if (isLoggedUser) {
      primaryText = (
        <span styleName="helperContainer">
          <span>{primaryText}</span>
          <FormattedMessage {...YOU} />
          {intro}
        </span>
      );
    }
  }

  return (
    <div {...{ className, style }} styleName="root" onClick={handleClick}>
      <If condition={additionalContent.left}>
        <div styleName="icon icon--left" children={additionalContent.left} />
      </If>
      <div styleName="textWrapper" className="text-block">
        <If condition={primaryText}>
          <div styleName="chatWrapper">
            {!isEmpty(additionalIcons) &&
              additionalIcons.map(icon => (
                <Icon
                  style={{
                    marginRight: '4px',
                    alignSelf: 'baseline',
                    fill: icon.fill,
                  }}
                  name={icon.name}
                  height={icon.height}
                  width={icon.width}
                  key={icon.name}
                />
              ))}
            <span
              // styleName="text text--primary"
              styleName={cn('text text--primary', {
                bold: withGreyHover,
              })}
            >
              {primaryText}
              <If condition={!isLoggedUser}>{intro}</If>
            </span>
          </div>
        </If>
        <If condition={text.complementary}>
          <span styleName="text text--secondary">{text.complementary}</span>
        </If>
      </div>
      <If condition={additionalContent.right}>
        <div styleName="icon icon--right" children={additionalContent.right} />
      </If>
    </div>
  );
};

Card.propTypes = {
  withGreyHover: PropTypes.bool,
  additionalContent: PropTypes.shape({
    left: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.node,
      PropTypes.element,
    ]),
    right: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.node,
      PropTypes.element,
    ]),
  }),
  className: PropTypes.string,
  text: PropTypes.shape({
    primary: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.node,
      PropTypes.string,
    ]),
    complementary: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.node,
      PropTypes.string,
    ]),
    className: PropTypes.string,
    intro: PropTypes.string,
  }).isRequired,
  userId: PropTypes.number,
  providerId: PropTypes.number,
  handleClick: PropTypes.func,
  loggedUser: PropTypes.object,
  style: PropTypes.object,
  additionalIcons: PropTypes.array,
};

Card.defaultProps = {
  handleClick: () => {},
};

const mapStateToProps = state => ({
  loggedUser: selectUserToShow(state),
});

export default connect(mapStateToProps)(
  CSSModules(Card, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Card/index.jsx